import { useState, type JSX } from 'react'
import SmoothCollapse from 'react-smooth-collapse'
import './Accordion.css'

export interface IAccordionProps {
  itemTitle: JSX.Element | string
  itemContent: JSX.Element | string
  isExpandedDefault?: boolean
  addClass?: string
  customExpandElement?: JSX.Element | string
  customCollapseElement?: JSX.Element | string
  onlyChevronClickable?: boolean
  buttonRole?: string
}

const Accordion = (props: IAccordionProps) => {
  const {
    itemTitle,
    itemContent,
    isExpandedDefault = false,
    addClass = '',
    customExpandElement,
    customCollapseElement,
    onlyChevronClickable = false,
    buttonRole = 'button',
  } = props

  const [isExpanded, setIsExpanded] = useState(isExpandedDefault)

  const accordionTitle = () => {
    return typeof itemTitle === 'string' ? (
      <h2 className="text-lg pr-4 Accordion__title">{itemTitle}</h2>
    ) : (
      itemTitle
    )
  }

  const accordionButtonIcon = () => {
    const defaultIcon = (
      <i
        className={`Icon bx bx-chevron-down text-3xl ${
          isExpanded ? 'ExpandedIcon' : ''
        }`}
      ></i>
    )
    if (customExpandElement || customCollapseElement) {
      if (customExpandElement && customCollapseElement)
        return isExpanded ? customCollapseElement : customExpandElement
      if (customExpandElement)
        return isExpanded ? defaultIcon : customExpandElement
      if (customCollapseElement)
        return isExpanded ? customCollapseElement : defaultIcon
    } else {
      return defaultIcon
    }
  }

  return (
    <div
      className={`Accordion ${addClass} ${
        isExpanded ? 'Accordion__expanded' : ''
      }`}
    >
      {onlyChevronClickable ? (
        <div data-testid="accordion-container">
          <div className="Accordion__title Accordion_wrapper">
            {accordionTitle()}
            <button
              role={buttonRole}
              onClick={() => setIsExpanded(!isExpanded)}
              aria-expanded={isExpanded}
              className="Accordion_ChevronButton"
            >
              {accordionButtonIcon()}
            </button>
          </div>
        </div>
      ) : (
        <button
          role={buttonRole}
          onClick={() => setIsExpanded(!isExpanded)}
          aria-expanded={isExpanded}
          data-testid="accordion-button"
          className="Accordion_Button"
        >
          <div className="Accordion__title">{accordionTitle()}</div>
          {accordionButtonIcon()}
        </button>
      )}
      <SmoothCollapse expanded={isExpanded} allowOverflowWhenOpen={true}>
        <div
          className="Accordion__content-wrapper"
          data-testid="accordion-content"
        >
          {itemContent}
        </div>
      </SmoothCollapse>
    </div>
  )
}

export default Accordion
